module.exports = __webpack_public_path__ + "media/images/success-img/layer-7-bd6e2e29ba099d03ed580f92b2bce196.png";